define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query",
	"./ProductType"
], function(declare, lang, Action, Relationship, ViewRef, Ref, xml, Query, ProductType) {

	var _getTheme = function(ctx) {
		var style = ctx.getNodeParent(null, true);
		return ctx.cache.getNode(style?.Theme, true);
	};

	return declare(Ref, {
		getStoreRelationship: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return relationship to use for heading store
			var theme = _getTheme(ctx);
			var style = ctx.getNodeParent(null, true);
			if (theme && !theme.LimitColorColorways) {
				// if we are on a Style, remove the ColorSpecs tied to the Colorways in the Style
				var q = new Query();

				q.Or()
					.Node("Type", xml.OP_EQUALS, "ColorSpecification")
					.Node("Type", xml.OP_EQUALS, "PrintDesignColor");

				q.Attr("Available", xml.OP_EQUALS, true, "Parent:Actual(ColorColorwayContext)");
				q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, theme.$URL, "Parent:Actual(ColorColorwayContext)");

				var colorways = ctx.cache.getNodes(style.ActiveColorways);
				colorways.forEach(function(c) {
					var cs = c && c.ColorSpecification;
					if (xml.isValidURL(cs)) {
						q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, cs);
					}
				});

				return lang.mixin(new Relationship(), {
					m_query: q
				});
			}

			return this.inherited(arguments);
		},

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if theme limits colorways, then do not need to query for store - otherwise query for all active colors
			const theme = _getTheme(ctx);
			const style = ctx.getNodeParent(null, true);
			const rule = style && ProductType.get(style, "ColorPaletteRule");
			if (!theme || !theme.LimitColorColorways || rule == "ColorPaletteRuleTypes:Enabled") {
				var fixedQry = new Query().Attr("Active", xml.OP_EQUALS, true);
				fixedQry.Attr("OKForStyle", xml.OP_EQUALS, true);
				return lang.mixin(new Action(), {
					m_fixedQuery: fixedQry,
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "ProductColorSpecs",
						m_url: "centric://APPAREL/Views"
					})
				});
			}

			return this.inherited(arguments);
		}
	});
});
